import { Component } from 'preact';
import DailyChart from '../../utils/daily-chart';

/**
 * The DailyChartWrapper component is a wrapper around a DailyChart instance, which renders
 * a chart to the DOM outside of Preact control.
 *
 * NOTE: data passed down is already converted into the units set by the user.
 *
 * props:
 * - data: The data set for the daily chart. An array of objects, each containing daily record data
 * - w: The window width (pixels)
 */

class DailyChartWrapper extends Component {

	constructor(props, context) {
		super(props, context);
		this.units = context.userSettings.units;
		this.container = null;
		this.chart = null;
	}

	shouldComponentUpdate(nextProps) {
		// Component should not update, instead when new props are received
		// we will redraw the chart manually.
		return false;
	}

	componentWillReceiveProps(nextProps) {
		// Redraw the chart if the data has changed of the w parameter (window width)
		// changed. As a performance optimisation, only recreate the chart instance
		// if the data itself changed.
		if (nextProps.data !== this.props.data) {
			this.chart = new DailyChart(nextProps.data, this.units);
		}
		if (nextProps.data !== this.props.data || nextProps.w !== this.props.w) {
			this.chart.render(this.container);
		}
	}

	componentDidMount() {
		// When the component is first mounted, create a chart instance and render it.
		this.chart = new DailyChart(this.props.data, this.units);
		this.chart.render(this.container);
	}

	render(props) {
		return <div class="hw_daily_chart" ref={el => { this.container = el; }} />;
	}

}

export default DailyChartWrapper;



// WEBPACK FOOTER //
// ./components/daily-chart/index.js